import { useState } from 'react';
import {
  Box,
  Divider,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  IconButton
} from "@mui/material";

import { Formik } from 'formik';
import axios from  'axios';

import {
  Facebook,
  Instagram,
  Search,
  ShoppingCartOutlined,
  ShoppingCart,
  Telegram
} from "@material-ui/icons";

import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import mainLogo from '../assets/logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import LoginIcon from '@mui/icons-material/Login';

const Container = styled.div`
  height: 90px;
`;

const Wrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const SearchContainer = styled.div`
  border: 0.5px solid lightgray;
  display: flex;
  align-items: center;
  margin-left: 25px;
  padding: 7px;
`;

const Input = styled.input`
  border: none;
`;

const Center = styled.div`
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 700;
  @media only screen and (max-width:900px) {
    display: none;
  }
  @media only screen and (max-width:1280px) {
    font-size: 16px;
    font-weight: 700;
  }
  @media only screen and (max-width:1024px) {
    font-size: 14px;
    font-weight: 700;
  }
`;

const Logo = styled.h1`
  font-weight: bold;
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media only screen and (max-width:600px) {
    display: none;
  }
`;

const CartItem = styled.div`
  position: absolute;
  color: white;
  padding: 2px;
  border-radius: 30%;
  background-color: red;
  opacity: 0.8;
`;

const LinkText = styled.a`
  color: #000000;
  text-decoration: none;
  &:hover {
    color: #999D9F;
    cursor: pointer;
    text-decoration: none
  }
`;

const SocialContainer = styled.div`
  display: flex;
`;
  
const SocialIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  background-color: #${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
`;

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '80%', md: 400 },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const Navbar = (Props) => {

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClickMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
      setAnchorEl(null);
    };
    const [authError, setAuthError] = useState(false);

    return (
        <Container>
            <Wrapper>
                <Left>
                    <Link to="/">
                      <img src={mainLogo} />
                    </Link>
                </Left>
                <Center>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                      <LinkText>BERANDA</LinkText>
                    </Link>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                      <LinkText>MITRA KAMI</LinkText>
                    </Link>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                      <LinkText>KATALOG</LinkText>
                    </Link>
                    <LinkText onClick={handleOpen}>LOGIN</LinkText>
                </Center>
                <Right>
                  <SocialContainer>
                    <SocialIcon color="3B5999">
                      <Facebook />
                    </SocialIcon>
                    <SocialIcon color="E4405F">
                      <Instagram />
                    </SocialIcon>
                    <SocialIcon color="55ACEE">
                      <Telegram />
                    </SocialIcon>
                  </SocialContainer>
                </Right>
                <Grid
                  item
                  xs={1}
                  sx={{
                    display: { xs: 'block', md: 'none' }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <IconButton
                      onClick={handleClickMenu}
                      size="small"
                      sx={{ ml: 2 }}
                      aria-controls={openMenu ? 'account-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openMenu ? 'true' : undefined}
                    >
                      <MenuIcon sx={{ fontSize: '44px' }}/>
                    </IconButton>
                  </Box>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={openMenu}
                    onClose={handleCloseMenu}
                    onClick={handleCloseMenu}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        width: '100%',
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.2,
                        '& .MuiAvatar-root': {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        '&:before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: 'background.paper',
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem>
                      Beranda
                    </MenuItem>
                    <MenuItem>
                      Mitra Kami
                    </MenuItem>
                    <MenuItem>
                      Katalog
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleOpen}>
                      <ListItemIcon>
                        <LoginIcon fontSize="small" />
                      </ListItemIcon>
                      Login
                    </MenuItem>
                  </Menu>
                </Grid>
            </Wrapper>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={modalStyle}>
                <Formik
                  initialValues={{ email: null, password: null }}
                  validate={values => {
                    const errors = {};
                    if (!values.email) {
                      errors.email = 'Required';
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    ) {
                      errors.email = 'Invalid email address';
                    }
                    return errors;
                  }}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, values);
                      setAuthError(false);
                      if (response.data.token) {
                        localStorage.setItem('token', JSON.stringify(response.data));
                        navigate('/dashboard');
                      }
                    } catch (err) {
                      console.log(err);
                      setAuthError(true);
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ textAlign: 'center' }}>
                          <Typography id="modal-modal-title" variant="h6" component="h2">
                            LOGIN MITRA
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            id="outlined-basic"
                            label="Email"
                            variant="outlined"
                            name="email"
                          />
                          <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                            {errors.email && touched.email && errors.email}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="password"
                            id="outlined-basic"
                            label="Password"
                            variant="outlined"
                            name="password"
                          />
                          <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                            {errors.password && touched.password && errors.password}
                          </Typography>
                        </Grid>
                        {authError && (
                          <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                            <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                              Email atau password tidak valid
                            </Typography>
                          </Grid>  
                        )}
                        <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                          <Button variant="contained" type="submit" disabled={isSubmitting}>Login</Button>
                        </Grid>
                      </Grid>
                    </form>
                  )}
                </Formik>
              </Box>
            </Modal>
        </Container>
    )
}

export default Navbar
